<app-centre-small-opener>
    <h2 mat-dialog-title dialogTitle class="title mar-b-5 confirm-dialog">{{title}}</h2>
    <div contentContainer class="row">
      <div class="col-lg-12 col-sm-12">
        <h3 class="body-font-size">{{content}}</h3>
      </div>
    </div>
    <button mat-raised-button actions class="button-container primary" (click) = "confirm(true)">
        YES
    </button>
    <button mat-raised-button actions class="button-container primary" mat-dialog-close>
        NO
    </button>
</app-centre-small-opener>